<a id="printBtn" title="Print" (click)="onPrintEvent()">
  <ng-content></ng-content>
</a>
